import UpdateSchemeVillage from "../components/configuration/SchemeVillage/UpdateSchemeVillage";

const UpdateSchemeVillagePage = () => {
  return (
    <UpdateSchemeVillage />
  );
};  

export default UpdateSchemeVillagePage;
